module.exports = __webpack_public_path__ + "public/Icons/user.svg?e9fdcd5f";